namespace GeniuzPOS.PosShift {
    export class ReportVatRefundColumns {
        static columnsKey = 'PosShift.ReportVatRefund';
    }
}
